import { render, staticRenderFns } from "./suggestDetails.vue?vue&type=template&id=4e99828b&scoped=true&"
import script from "./suggestDetails.vue?vue&type=script&lang=js&"
export * from "./suggestDetails.vue?vue&type=script&lang=js&"
import style0 from "./suggestDetails.vue?vue&type=style&index=0&id=4e99828b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e99828b",
  null
  
)

export default component.exports